import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Ausentismos } from '../models/ausentismos';
import {HttpClient, HttpResponse} from '@angular/common/http';

const baseUrl = environment.hostService + '/PersonalAusentismos';

@Injectable({
  providedIn: 'root'
})
export class AusentismosService {

  constructor(private _http: HttpClientService,
    private http: HttpClient,) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  guardar(data): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save', body: data, cacheMins: 0 });
  }

  eliminar(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getByPersonal(id: number, agrupar: boolean): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + id + '/' + agrupar })
  }

  GetCantidadByPeriodo(fechaDesde: string, fechaHasta: string): Observable<any>
  {
    return this.http.get(baseUrl + '/GetCantidadByPeriodo?fechaDesde=' + fechaDesde + '&fechaHasta=' + fechaHasta)
  }

  getHistoryByClase(idPersonal: number, claseAusentismo: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByClase/' + idPersonal + '/' + claseAusentismo });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        claseAusentismo: '', 
        horaDesde: '00:00',
        horaHasta: '00:00',
        errores: ['No Completar']}
    ];

    //claseAusentismo se deben validar que existan

    return formato;
  }
}
